import React from "react";
import { COLORS } from "../../utils/constants";

const Toggle = ({ value, options, onChange, testid }) => (
  <div className="inline-flex rounded-lg border p-1 bg-white" data-testid={testid}>
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        onClick={() => onChange(o.value)}
        data-testid={`${testid}-${o.value}`}
        className="px-3 py-1.5 rounded-md text-sm font-medium transition-colors"
        style={value === o.value ? { backgroundColor: COLORS.text, color: "white" } : { color: COLORS.text }}
      >
        {o.label}
      </button>
    ))}
  </div>
);

const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-xs font-medium text-muted-foreground mb-1 block">{label}</span>
    {children}
  </label>
);

const inputCls = "w-full h-10 px-3 rounded-lg border bg-white text-base font-semibold focus:outline-none focus:ring-2";

export const ContratForm = ({ form, setForm, hasDouble, minMois }) => {
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const mensuel = form.mode === "mensuel";
  return (
    <div className="rounded-xl border p-5 space-y-4" style={{ backgroundColor: COLORS.bg }} data-testid="simulateur-form">
      <div className="flex flex-wrap gap-3 items-center">
        <Toggle
          testid="simulateur-mode"
          value={form.mode}
          onChange={(v) => set("mode", v)}
          options={[{ value: "total", label: "Montant total" }, { value: "mensuel", label: "Montant par mois" }]}
        />
        {hasDouble && (
          <Toggle
            testid="simulateur-activite"
            value={form.activite}
            onChange={(v) => set("activite", v)}
            options={[{ value: "principal", label: "Activité principale" }, { value: "secondaire", label: "Activité secondaire" }]}
          />
        )}
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        <Field label={mensuel ? "Montant HT par mois" : "Montant HT total du contrat"}>
          <div className="relative">
            <input type="number" min="0" step="100" value={form.montant} onChange={(e) => set("montant", e.target.value)}
              className={`${inputCls} pr-8`} style={{ color: COLORS.text }} data-testid="simulateur-montant" />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-semibold" style={{ color: COLORS.text }}>€</span>
          </div>
        </Field>
        {mensuel && (
          <Field label="Durée (mois)">
            <input type="number" min="1" max="36" value={form.nb_mois} onChange={(e) => set("nb_mois", e.target.value)}
              className={inputCls} style={{ color: COLORS.text }} data-testid="simulateur-nb-mois" />
          </Field>
        )}
        <Field label={mensuel ? "Premier encaissement" : "Mois d'encaissement prévu"}>
          <input type="month" min={minMois} value={form.mois_debut} onChange={(e) => set("mois_debut", e.target.value)}
            className={inputCls} style={{ color: COLORS.text }} data-testid="simulateur-mois-debut" />
        </Field>
      </div>
      <p className="text-xs text-muted-foreground">
        En micro-entreprise, le CA compte au mois où il est <strong>encaissé</strong> : c'est ce mois qui sert pour les cotisations, les seuils et la retraite.
      </p>
    </div>
  );
};

export default ContratForm;
